import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// 購入時アンケート集計結果のもっと見るボタン
export class QuestionnaireController extends Controller {
  static targets = [
    "button",
    // 一覧のアイテム
    "item",
    // 一覧以外の切り替え対象
    "help",
  ];
  static values = {
    // 常に表示する数
    count: { type: Number, default: 10 },
    // 初期表示状態
    visible: { type: Boolean, default: false },
    // jQueryのエフェクト
    effect: { type: String, default: "fade" },
  };
  static classes = ["hidden"];

  connect() {
    this.#update();
    // もっと見る必要が無ければボタンを隠す
    if (this.hasButtonTarget && this.itemTargets.length <= this.countValue) {
      this.buttonTarget.style.display = "none";
    }
  }

  toggle(event) {
    if (this.visibleValue) {
      this.hide(event);
    } else {
      this.show(event);
    }
  }

  show(event) {
    this.visibleValue = true;
    // ボタンのテキストを切り替える
    const button = event.target;
    if (button.dataset.hideText) {
      if (!button.dataset.showText) button.dataset.showText = button.textContent;
      button.textContent = button.dataset.hideText;
    }
    button.classList.add("is-open");
    // スクロール位置を保存
    this.scrollTop = window.scrollY;
    this.#update();
  }

  hide(event) {
    this.visibleValue = false;
    const button = event.target;
    if (button.dataset.showText) {
      if (!button.dataset.hideText) button.dataset.hideText = button.textContent;
      button.textContent = button.dataset.showText;
    }
    button.classList.remove("is-open");
    // smoothにスクロール
    if (this.scrollTop) {
      window.scrollTo({ top: this.scrollTop, behavior: "smooth" });
    }
    this.#update();
  }

  #update() {
    this.itemTargets.forEach((item, index) => {
      if (index >= this.countValue) {
        this.#updateElement(item);
      }
    });
    for (const help of this.helpTargets) {
      this.#updateElement(help);
    }
  }
  #updateElement(element) {
    if (this.effectValue === "fade") {
      if (this.visibleValue) $(element).fadeIn();
      else $(element).fadeOut();
    }
    if (this.hasHiddenClass) {
      element.classList.toggle(this.hiddenClasses, !this.visibleValue);
    }
  }
}
